export default "__VITE_ASSET__Dqd8AM3q__"